<template>
  <div class="w-100">
    <slot></slot>
  </div>
</template>

<script>
  import { AlertManager } from '../components/utils/AlertManager'

  export default {
    name: 'GeneralListOfProtocolsReport',
    mounted () {
      window.livewire.on('loadingReport', () => {
        $('#export-modal').modal('show')
        
        window.livewire.emit('exportReport')
      })
      
      window.livewire.on('reportLoaded', (file) => {
        $('#export-modal').modal('hide')
        
        location.href = file
      })
      
      window.livewire.on('reportQueued', (file) => {
        $('#export-modal').modal('hide')
        
        AlertManager.success('Se enviará el reporte a su correo.')
        
        setTimeout(() => {
          $('#ready-modal').modal('show')
        }, 1000)
      })
    },
  }
</script>
